let html = `<div class="account-modal">
    <div class="account-modal__icon">
        <svg width="86" height="93" viewBox="0 0 86 93" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="42.6763" cy="23.3238" r="19.3238" stroke="white" stroke-width="8"/>
            <path d="M81.3524 93C81.3524 71.6398 64.0365 54.3239 42.6762 54.3239C21.3159 54.3239 4 71.6398 4 93" stroke="white" stroke-width="8"/>
        </svg>
    </div>

    <div class="account-modal__desc">
        #{account_create}
    </div>
</div>`

export default html